import {STATE_PROP} from './companies-display-constants'

export const getRoot = state => state[STATE_PROP]
export const getByKey = (key, state) => getRoot(state)[key]
